import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Home from './Home/Home'
import NotFound from './NotFound/NotFound'
import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary'
import { ModalWrapper, Modal } from '@gluedigital/modal'
import Program from './Program/Program'
import CalendarPage from './CalendarPage/CalendarPage'
import Privacy from './PrivacyPage/Privacy'
import { Helmet } from "react-helmet-async"

const App = () => {

  return (
    <ModalWrapper>
      <Helmet>
        <script>
          {`
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${process.env.GOOGLE_TAG_MANAGER_TAG}');
          `}
        </script>
      </Helmet>

      <main id="app">
        <ErrorBoundary>
          <Switch>
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/program" exact>
              <Program />
            </Route>
            <Route path="/calendar" exact>
              <CalendarPage />
            </Route>
            <Route path="/privacy">
              <Privacy />
            </Route>
            <Route>
              <NotFound />
            </Route>
          </Switch>
        </ErrorBoundary>
        <Modal />
      </main>
    </ModalWrapper>
  )
}

export default App
